// https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
// has class based useref
import React             from 'react';
import { Scatter }       from 'react-chartjs-2';
import { useRef }        from 'react';
import NoteService       from '../../services/NoteService';
import FretboardService  from '../../services/FretboardService';
import AllNotesService   from "../../services/AllNotesService";
import ColorRadiiService from "../../services/ColorRadiiService";

import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from 'chart.js';

function areAllFound(dataObject, colorService, changeColor, that) {
    let dataset = dataObject.datasets[0]
    let allDone = true;

    let correctColor = colorService.goodColor();
    for(var i=0; i<dataset.data.length; i++) {
        let hiddenColor =  dataset.data[i].c
        let visibleColor = dataset.backgroundColor[i]

        if(hiddenColor===correctColor && hiddenColor!==visibleColor) {
            allDone = false;
        }
    }
    if(allDone) {
        if(changeColor != null) {
            changeColor("btn btn-success col-12", that)
        }
    }
    return allDone;
}

function generateHiddenColors(colors) {
    let hiddenColors = []
    for(var i=0; i<colors.length; i++) {
        hiddenColors.push('white')
    }
    return hiddenColors
}

function getFretboardService(noteService) {
    let min           = noteService.getYMin();
    let max           = noteService.getYMax();
    let fretboardService     = new FretboardService(min, max);
    return fretboardService;
}

function getClick(hidedots) {
    if(hidedots) {
        return 'click'
    }
    return null;
}
export default function Fretboard({ notes, fretStart, fretEnd, callback, that, helpNotes,
                                  hidedots}) {
    let   fretboardService              = null;
    let   _colorService      = new ColorRadiiService();
    let   _changeColor                  = null;
    let  clickevent = getClick(hidedots)
    ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend);

    let _colors       = [];
    let _dataObject      = {};
    let _that           = null;

     const options = {

        onClick: function(c,i){
            let e = i[0];
            let idx = e.index
            let color = _colors[idx]
            let allFound = false;

            if(color!=='#000000') {
                _dataObject.datasets[0].backgroundColor[idx]=color
                _dataObject.datasets[0].pointRadius[idx]=15
                allFound = areAllFound(_dataObject, _colorService, _changeColor, _that)
            }
        },
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            tickFormat: {
                notation: 'compact'
            },
            tooltip: {
                enabled: false
            }
        },

        scales: {
            y: {
                border: {
                    display: false
                },
                grid: {
                    lineWidth:  function(context) {
                        return fretboardService.getHLineThickness(context.tick.value);
                    },
                    color: function(context) {
                        return fretboardService.getHLineColor(context.tick.value)
                    },
                },
                ticks: {
                    autoSkip: false,
                    callback: function(val, index) {
                        let yTick = fretboardService.getYTicks(val);
                        return yTick;
                    },
                    stepSize: 0.5,
                    color: _colorService.goodColor(),
                }
            },

            x: {
                grid: {
                    lineWidth:  function(context) {
                        return fretboardService.getStringThickness(context.tick.value);
                    },
                    color: function(context) {
                        return fretboardService.getStringColor(context.tick.value);
                    }
                },
                ticks: {
                    autoSkip: false,
                    callback: function(val, index) {
                        return "";
                    },
                },
            }
        },
        events: [clickevent],
        interaction: {
            mode: "nearest",
            intersect: false,
        },
    };


    _changeColor = callback
    _that = that

    // showCurrentTime()
    let allNoteService = new AllNotesService();
    let patNotes = null;
    if(helpNotes !== null) {
        patNotes = helpNotes
    }
    else {
        patNotes = allNoteService.getFretData(notes, fretStart, fretEnd)
    }

    let noteService = new NoteService(patNotes);
    let noteData    = noteService.getGraphFormattedNotes();
    _colors = noteService.getNotePropertyData('c')
    let hiddenColors= generateHiddenColors(_colors)
    if(!hidedots) {
        for(var i=0; i<_colors.length; i++) {
            if(_colors[i] != '#000000') {
                hiddenColors[i] = _colors[i]
            }
        }
    }
    //hiddenColors[0] = 'blue'
    let radii = noteService.getRadii(hiddenColors)


    fretboardService = getFretboardService(noteService)

    const chartRef = useRef();

    _dataObject = {
        datasets: [ {
            data: noteData,
            backgroundColor: hiddenColors,
            pointRadius: radii,
            pointHoverRadius: 15,
            pointHoverBackgroundColor: noteService.getNotePropertyData('h')
        },
        ],
    };

    return (
        <div>
            <Scatter id='pat' options={options} ref={chartRef} data={_dataObject}  />
        </div>
    );
}
export const MemoizedFretboard = React.memo(Fretboard);
